/**
 * 在用户点击同步栈内打开新窗口（Safari 友好）
 * @param {string} url
 * @returns {boolean}
 */
export function openUrlInNewWindow (url) {
  if (!url) return false
  try {
    const a = document.createElement('a')
    a.href = url
    a.target = '_blank'
    a.rel = 'noopener noreferrer'
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    return true
  } catch (e) {
    try {
      window.open(url, '_blank')
      return true
    } catch (e2) {
      return false
    }
  }
}

/**
 * 异步拿到 URL 后再新开页：必须在点击同步阶段调用。
 * Safari 会拦截「接口回调里再 window.open」，因此先同步打开空白页，返回后再改 location。
 * @returns {{ navigate: (url: string) => boolean, cancel: () => void, opened: boolean }}
 */
export function prepareAsyncNewWindow () {
  let win = null
  try {
    // 不要带 noopener：否则部分浏览器 window.open 返回 null，无法后续赋值
    win = window.open('about:blank', '_blank')
  } catch (e) {
    win = null
  }
  return {
    opened: !!(win && !win.closed),
    navigate (url) {
      if (!url) {
        if (win && !win.closed) win.close()
        return false
      }
      if (win && !win.closed) {
        try {
          win.opener = null
        } catch (e) { /* ignore */ }
        try {
          win.location.href = url
          return true
        } catch (e) {
          try {
            win.location.replace(url)
            return true
          } catch (e2) {
            win.close()
          }
        }
      }
      return openUrlInNewWindow(url)
    },
    cancel () {
      if (win && !win.closed) {
        try {
          win.close()
        } catch (e) { /* ignore */ }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/badges/utils/openWindow.js